import { Component, OnInit, ViewChildren } from '@angular/core';
import { TimelineService } from '../../services/timeline.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { TimelineResponse } from '../../models/timeline';
import { LoadingService } from 'src/app/core/services/loading.service';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { environment } from 'src/environments/environment';
import { AddTimelineComponent } from '../add-timeline/add-timeline.component';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { first, last } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IonPopover } from '@ionic/angular';
 
@Component({
  selector: 'app-timeline-v2',
  templateUrl: './timeline-v2.component.html',
  styleUrls: ['./timeline-v2.component.scss'],
})
export class TimelineV2Component extends BaseModal implements OnInit {
  baseImageUrl = environment.baseImageUrl;
  cropId: number;
  farmId: number;
  querySubs: Subscription;
  list: Array<TimelineResponse> = [];
  height: number = 230;
  databaseError: boolean = false;
  loading: boolean = true;
  isComplete: boolean = false;
  // isEdit: boolean = false;
  dateArr: Array<any> = [];
  currentStep: string;
  currentStage: TimelineResponse;
  noTimeline: boolean = true;
  stageTypeId: number;
  editedList: Array<any> = [];
  completeDateArray: Array<any> = [];
  @ViewChildren(IonPopover) popovers: any;
  constructor(
    private timelineService: TimelineService,
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private modalService: ModalService,
    private storageService: StorageService) {
    super();
    super._modalService = modalService
  }
 
  ngOnInit() { }
  ionViewDidEnter() {
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["farmId"]) {
        this.farmId = +e["farmId"];
      }
      if (e["cropId"]) {
        this.cropId = +e["cropId"];
      }
      if (e["stageTypeId"]) {
        this.stageTypeId = +e["stageTypeId"];
        let index; let stage;
        if (this.stageTypeId) {
          this.editedList.forEach((e, i) => {
            if (e.StageTypeId == this.stageTypeId) {
              stage = e;
              index = i;
              this.addDate(stage, i);
            }
          })
        }
 
      }
      setTimeout(() => {
        this.getTimelineList();
      }, 100);
    });
  }
 
  ionViewDidLeave() {
    if (typeof this.querySubs != "undefined") {
      this.querySubs.unsubscribe();
    }
  }
 
  getTimelineList() {
    let date = new Date();
    this.list = [];
    this.dateArr = [];
    this.editedList = [];
    this.loadingService.showLoading();
    this.timelineService.getTimelineList(this.farmId, this.cropId).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.list = res.Data;
        let firstElem = this.list[0];
        let lastElem = this.list[this.list.length - 1];
        this.editedList.push(firstElem, lastElem, ...this.list.slice(1, -1));
        this.currentStage = this.editedList.find(e => e.CurrentStageId == e.StageTypeId);
        this.editedList.forEach(elem => this.dateArr.push(elem?.TimeLineLogDate))
        this.dateArr.forEach(e => {
          if (e) {
            this.completeDateArray.push(e);
            if (this.completeDateArray.length > 0) {
              // this.isEdit = true;
              this.noTimeline = false;
              if (this.completeDateArray.length == this.editedList.length) {
                this.isComplete = true;
              } else {
                this.isComplete = false
              }
            } else {
              // this.isEdit = false;
              this.noTimeline = true;
            }
          }
        })
      }
    }, err => {
      this.loadingService.hideLoading();
    })
  }
 
  addDate(stageItem, index) {
    let date = stageItem.TimeLineLogDate
    if (!date) {
      date = new Date();
    }
    this.modalService.presentModal({
      component: AddTimelineComponent,
      componentProps: {
        date: date,
        currentStep: stageItem,
        stageList: this.editedList,
        activeIndex: index,
        farmId: this.farmId,
        cropId: this.cropId,
        dateArr: this.dateArr,
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.role == "date") {
          this.getTimelineList();
          if (this.popovers?.length) {
            this.popovers.forEach(popover => {
              popover.dismiss();
            });
          }
        }
        else{
          if (this.popovers?.length) {
            this.popovers.forEach(popover => {
              popover.dismiss()
            });
          }
        }
      });
    });
  }
 
  deleteItem(id) {
    this.loadingService.showLoading();
    this.timelineService.deletePhenologyList(id).subscribe(data => {
      this.getTimelineList();
      if (this.popovers?.length) {
        this.popovers.forEach(popover => {
          popover.dismiss()
        });
      }
      this.loadingService.hideLoading();
    })
  }
}